import { createSelector } from '@reduxjs/toolkit';

const selectShowsState = (state: any) => state.show;

export const selectShowsSelector = createSelector(
  [selectShowsState],
  (show) => ({
    page: Number(show.showsListParams.page),
    per_page: Number(show.showsListParams.per_page),
    total: Number(show.showsListParams.total),
    shows: show.shows
})
);

export const selectShowLoading = createSelector(
  [selectShowsState],
  (show) => show?.loading
);

export const selectShowAdminLoading = createSelector(
  [selectShowsState],
  (show) => show?.adminLoading
);

export const selectShowById = (id: string) => createSelector(
  [selectShowsSelector],
  (show) => show?.shows?.find((show: any) => show._id === id)
);
